<template>
  <div class="content">
    {{ Language.say(notification.message, notification.replacements) }}
  </div>
</template>
<script setup>
  import {defineProps}   from 'vue';
  import Language        from '@/js/Shared/Language/Language.js';

  const props = defineProps({
    notification: Object
  });
</script>
